/**
 * Role Name enum of the user. Used in the authentication process.
 * NOTE: The list should get reviewed when user roles get defined better.
 */
export enum RoleName {
  ADMIN = 'Admin',
  MANAGER = 'Manager',
  VISITOR = 'Visitor',
  CUSTOMER = 'Customer',
  PAYMENT_INTEGRATION = 'PaymentIntegration',
  GIT_CARD_INTEGRATION = 'GiftCardIntegration',
  DELIVERY_PROVIDER = 'DeliveryProvider',
  DEFAULT = 'Visitor'
}

